import React from "react";
import { Link } from "gatsby";
import { DateTime } from "luxon";
import formatdate from "~/helpers/formatdate";
import Dotdotdot from "react-dotdotdot";

type Props = {
  url: {
    pathname: string;
  };
  createdAt: DateTime;
  title: string;
  description: string;
};

const ListItem = ({ url, createdAt, title, description }: Props) => {
  return (
    <Link
      to={url.pathname}
      className="flex flex-col sm:flex-row font-regular gap-4 sm:gap-8 lg:gap-[64px] items-start leading-[28px] sm:leading-[32px] lg:leading-[36px] text-[16px] sm:text-[17px] lg:text-[18px] w-full py-3 sm:py-7 lg:py-8 hover:bg-neutral-99 transition-colors px-4 sm:px-6 lg:px-8 rounded-none w1140:rounded-[40px]"
    >
      <p className="font-[400] text-[12px] sm:text-[13px] lg:text-[14px] shrink-0">
        {formatdate(createdAt)}
      </p>
      <div className="flex-1">
        <p className="font-[500] whitespace-pre-wrap text-[16px] sm:text-[17px] lg:text-[18px] leading-[24px] sm:leading-[28px] lg:leading-[32px]">
          {title}
        </p>
        <Dotdotdot
          clamp={3}
          className="font-[300] text-sm sm:text-base mt-2 leading-[1.5em] sm:leading-[1.6em]"
        >
          {description}
        </Dotdotdot>
      </div>
    </Link>
  );
};

export default ListItem;
